<template>
  <div class="store-detail">
    <NavHeaderBar :showSearch="false" :navBarTitle="$t('shared.title.storeVisit')">
      <div class="right-header" v-if="visitInfo.isEdit" @click="toPage(`/storeMaintain/storeVisit?visitId=${visitInfo.id}&customerId=${visitInfo.customerId}`)">
        Edit
      </div>
    </NavHeaderBar>
    <div class="detail-main-content">
      <div class="mark-info">
        <span class="customer-name">{{ visitInfo.customerName }}</span>
        <span class="tag-info" :class="visitInfo.customerTag | formatTagClass" v-if="!['', null].includes(visitInfo.customerTag)">{{ visitInfo.customerTag | formatTag }}</span>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.visitInfo') }}.</div>
        <div class="item-info">
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.name') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.createUserName }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.visitDate') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.visitTime }}</span>
          </div>
          <div class="item-section">
            <span class="left txt-ellipsis">{{ $t('form.checkInPhoto') }}</span>
            <span class="right" v-if="visitInfo.imgMap && visitInfo.imgMap.check">
              <img v-for="(subItem, subIndex) in visitInfo.imgMap.check.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.check)">
            </span>
          </div>
        </div>
      </div>
      <div class="info" v-if="isShowSellIn">
        <div class="item-title">{{ $t('form.listingStatus') }}</div>
        <div class="item-info">
          <div class="top-title">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.productListingStatus') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex">
            <div class="product-section" v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
              <div class="brand-title square">
                <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }} · {{ subItem.productName }}</span>
                <span class="custom-font" :class="{'end-of-sales': subItem.isShelf === -1}">{{ subItem.isShelf === 1 ? $t('form.listing') : subItem.isShelf === 0 ? $t('form.notListing') : subItem.isShelf === -1 ? $t('form.endOfSales') : '' }}</span>
              </div>
              <div v-if="subItem.isShelf === 1" class="quantity-content">
                <div class="qt-item" :class="{'jin': detaItem.isChoose}" v-for="(detaItem, detaIndex) in subItem.detailList" :key="detaIndex">
                  <span v-if="detaItem.isChoose">{{ detaItem.type }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="top-title" v-if="isShowSd">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.listingProductSupplierDistributor') }}</div>
            </div>
          </div>
          <div class="brand-section" v-for="(brandItem, brandIndex) in visitInfo.shelfList" :key="brandIndex + 'a'">
            <div class="brand-title square" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <span style="flex: 1;" class="van-ellipsis">{{ brandItem.projectName }}</span>
            </div>
            <div class="quantity-content" v-if="brandItem.expandInfo.sdList.length > 0 || brandItem.expandInfo.otherSd">
              <div class="qt-item jin" v-for="(detaItem, detaIndex) in brandItem.expandInfo.sdList" :key="detaIndex">
                <span>{{ detaItem.sdName }}</span>
              </div>
              <div class="qt-item jin" v-if="brandItem.expandInfo.otherSd">
                <span>{{ $t('form.other') }}：{{ brandItem.expandInfo.otherSd }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.totalOpenSales || visitInfo.totalDisposableSales">
        <div class="item-title">{{ $t('shared.psi') }}</div>
        <div class="item-info">
          <div class="item-section" v-if="visitInfo.totalOpenSales">
            <span class="left txt-ellipsis">{{ $t('form.totalOpenSystemsSales') }}</span>
            <span class="right custom-font txt-ellipsis">{{ visitInfo.totalOpenSales }}</span>
          </div>
          <div class="item-section" v-if="visitInfo.totalDisposableSales">
            <span class="left txt-ellipsis">{{ $t('form.totalDisposableSales') }}</span>
            <span class="right custom-font txt-ellipsis">{{ visitInfo.totalDisposableSales }}</span>
          </div>
          <div class="item-section" v-for="subItem in visitInfo.brandSaleList" :key="subItem.id">
            <span class="left txt-ellipsis">{{ subItem.projectName }} {{ $t('form.salesPcsWeek') }}</span>
            <span class="right custom-font txt-ellipsis">{{ subItem.sale }}</span>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.displayMerchandising') }}</div>
        <div class="item-info" v-if="visitInfo.materielList">
          <div class="custom-section" v-for="(subItem, subIndex) in visitInfo.materielList" :key="subIndex">
            <div class="top-info">
              <span class="left custom-left txt-ellipsis">{{ subItem.materielName }}</span>
              <span class="right custom-right custom-font txt-ellipsis">{{ ['', null].includes(subItem.isDisplayed) ? $t('shared.filter.unknown') : subItem.isDisplayed ? $t('shared.filter.yes') : subItem.isDisplayed == false ? $t('shared.filter.no') : '' }}</span>
            </div>
            <div class="desc-info" v-if="subItem.remark">{{ $t('form.notes') }}: {{ subItem.remark }}</div>
          </div>
        </div>
        <div class="item-info" v-if="visitInfo.imgMap && visitInfo.imgMap.material">
          <div class="item-section">
            <span class="left img-left txt-ellipsis">{{ $t('form.photo') }}</span>
            <span class="right img-right">
              <img v-for="(subItem, subIndex) in visitInfo.imgMap.material.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.material)">
            </span>
          </div>
        </div>
      </div>
      <div class="info" v-if="sampleListTotal > 0 || materialListTotal > 0 || (visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto)">
        <div class="item-title">{{ $t('form.materialSampleDelivery') }}</div>
        <div class="item-info is-Direct" v-if="sampleListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.sampleDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ sampleListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="sampleList.length > 0">
            <div class="material-item" v-for="subItem in sampleList" :key="subItem.id">
              {{ subItem.projectName }}·{{ subItem.productName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="item-info is-Direct" v-if="materialListTotal > 0">
          <div class="product-title square">
            <div class="left-desc">{{ $t('form.materialDelivery') }}</div>
            <div class="right">{{ $t('form.total') }} <span class="pcs-num">{{ materialListTotal }}</span> {{ $t('form.pcs') }}</div>
          </div>
          <div class="material-delivey" v-if="putMaterielList.length > 0">
            <div class="material-item" v-for="subItem in putMaterielList" :key="subItem.id">
              {{ subItem.materielName }}：{{ subItem.quantity }}
            </div>
          </div>
        </div>
        <div class="img-content" v-if="visitInfo.imgMap && visitInfo.imgMap.deliveryMaterialProto">
          <div class="img-imgMap-left">{{ $t('form.materialSamplePhoto') }}</div>
          <div class="img-right">
            <img v-for="(subItem, subIndex) in visitInfo.imgMap.deliveryMaterialProto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.deliveryMaterialProto)">
          </div>
        </div>
      </div>
      <div class="info" v-if="isShowAfterSale">
        <div class="item-title">{{ $t('form.storeServiceRecords') }}</div>
        <div class="item-info">
          <div class="top-title">
            <div class="right-title">
              <img class="ell-icon" src="@/assets/images/ell_icon.png" alt="">
              <div>{{ $t('form.afterSalesService') }}</div>
            </div>
          </div>
          <div v-for="(brandItem, brandIndex) in visitInfo.afterSaleList" :key="brandIndex">
            <div class="custom-section" v-if="brandItem.productList.length > 0">
              <div class="section-title square">
                <span style="flex: 1;">{{ brandItem.projectName }}</span>
              </div>
              <div v-for="(subItem, subIndex) in brandItem.productList" :key="subIndex">
                <div class="section-product-name">
                  <img class="jt-icon" src="@/assets/images/jt_icon.png" alt="">
                  <span>{{ $t('form.lssueDeviceMode') }}：{{ subItem.productName }}</span>
                </div>
                <div class="section-quantity-desc">
                  <div class="quantity-num">{{ $t('form.afterSalesQuantityPcs') }}：<span class="custom-font">{{ subItem.quantity }}</span></div>
                  <div class="desc-txt">{{ $t('form.lssusDescription') }}：{{ subItem.issueRemark }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && visitInfo.imgMap.servicePhoto">
            <div class="left img-left txt-ellipsis section-title square">{{ $t('form.servicePhoto') }}</div>
            <div class="right img-right">
              <img v-for="(subItem, subIndex) in visitInfo.imgMap.servicePhoto.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.servicePhoto)">
            </div>
          </div>
        </div>
      </div>
      <div class="info">
        <div class="item-title">{{ $t('form.kOSGroupInvitation') }}</div>
        <div class="item-info">
          <div class="item-section" v-if="visitInfo.invite">
            <span class="left txt-ellipsis">{{ $t('form.staffName') }}</span>
            <span class="right txt-ellipsis">{{ visitInfo.invite.staffName }}</span>
          </div>
          <div class="custom-section" v-if="visitInfo.imgMap && (visitInfo.imgMap.inviteUrl)">
            <div class="custom-photo-item">
              <span class="item-left">{{ $t('form.kOSGroupJoinScreenshot') }}</span>
              <span class="item-right">
                <img v-for="(subItem, subIndex) in visitInfo.imgMap.inviteUrl.split(',')" class="photo-img" :key="subIndex" :src="subItem" alt="" @click="imgPreview(subIndex, visitInfo.imgMap.inviteUrl)">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="info" v-if="visitInfo.feedback">
        <div class="item-title">{{ $t('shared.feedback') }}</div>
        <div class="item-info">
          <div class="item-section">
            {{ visitInfo.feedback }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { arsVisitInfoApi } from '@/api/visit'
import { ImagePreview, Toast } from 'vant'
import { mapState } from 'vuex'
import i18n from '@/i18n'
export default {
  filters: {
    formatTag (value) {
      return value === 0 ? i18n.t('shared.filter.toBeVerified') : value === 1 ? i18n.t('shared.filter.sVIPCore') : value === 2 ? i18n.t('shared.filter.vIPCore') : value === 3 ? i18n.t('shared.filter.potential') : ''
    },
    formatTagClass (value) {
      return `tag${value}`
    }
  },
  data () {
    return {
      paramsUrl: {},
      visitInfo: {},
      putMaterielList: [],
      sampleList: []
    }
  },
  activated () {
    this.paramsUrl = this.$route.query
    this.getVisitInfo()
  },
  deactivated () {
    this.$destroy()
  },
  computed: {
    ...mapState({
      globalData: 'globalData',
      userInfo: 'myUserInfo'
    }),
    materialListTotal () {
      return this.putMaterielList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    sampleListTotal () {
      return this.sampleList.reduce((acc, curr) => acc + Number(curr.quantity), 0)
    },
    isShowSellIn () {
      if (!this.visitInfo.shelfList || this.visitInfo.shelfList.length === 0) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem => {
        return brandItem.productList.length > 0
      })
    },
    isShowAfterSale () {
      if (!this.visitInfo.afterSaleList || this.visitInfo.afterSaleList.length === 0) {
        return false
      }
      return this.visitInfo.afterSaleList.some(brandItem => {
        return brandItem.productList.length > 0
      })
    },
    isShowSd () {
      if (!this.visitInfo.shelfList || this.visitInfo.shelfList.length === 0) {
        return false
      }
      return this.visitInfo.shelfList.some(brandItem => {
        return brandItem.expandInfo.sdList.length > 0 || !['', null].includes(brandItem.expandInfo.otherSd)
      })
    }
  },
  methods: {
    getVisitInfo () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsVisitInfoApi(this.paramsUrl.visitId).then(res => {
        Toast.clear()
        const { protoList, putMaterielList, shelfList } = res.data
        this.sampleList = protoList.filter(subItem => {
          return subItem.quantity > 0
        })
        this.putMaterielList = putMaterielList.filter(subItem => {
          return subItem.quantity > 0
        })
        res.data.brandSaleList = res.data.brandSaleList.filter(subItem => {
          return subItem.sale
        })
        shelfList.forEach(brandItem => {
          brandItem.expandInfo.sdList = brandItem.expandInfo.sdList || []
          brandItem.expandInfo.otherSd = brandItem.expandInfo.otherSd || ''
        })
        this.visitInfo = res.data
      })
    },
    imgPreview (index, url) {
      ImagePreview({
        images: url.split(','),
        startPosition: index
      })
    },
    getlocation (params) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      // 根据经纬度获取位置
      new google.maps.Geocoder().geocode(
        {
          location: new google.maps.LatLng(currentTimeLoc.lat, currentTimeLoc.lng)
        },
        function geoResults (results, status) {
          Toast.clear()
          // 这里处理结果和上面一模一样
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${results[0].formatted_address}&destination=${params.address}&waypoints=`
          } else {
            console.log('：error ' + status)
          }
        }
      )
    },
    toPage (url) {
      if (!url) {
        Toast(this.$t('tips.stayTuned'))
        return
      }
      this.$router.push(url)
    }
  }
}
</script>

<style lang="less" scoped>
.store-detail {
  display: flex;
  flex-direction: column;
  height: 100%;
  .right-header {
    font-size: 14px;
    color: #307bff;
  }
  .detail-main-content {
    flex: 1;
    overflow-y: auto;
  }
  .mark-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 10px;
    font-weight: 700;
    color: #555;
    .customer-name {
      text-align: center;
      word-break: break-word;
    }
    >span {
      font-size: 14px;
    }
    >span:nth-child(2) {
      margin-top: 5px;
    }
    .tag-info {
      padding: 3px 5px;
      text-align: center;
      font-size: 10px;
      border: 1px solid #ee541b;
      color: #ee541b;
      background-color: #eccfc4;
      margin-right: 6px;
    }
    .tag0 {
      border: 1px solid #0db00b;
      color: #0db00b;
      background-color: #abdaaa;
    }
    .tag2 {
      border: 1px solid #dc851f;
      color: #dc851f;
      background-color: #f0e2d1;
    }
    .tag3 {
      border: 1px solid #7f7f7f;
      color: #7f7f7f;
      background-color: #dcdcdc;
    }
  }
  .info {
    margin-bottom: 20px;
    .item-title {
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: bold;
      color: #307bff;
      &::before {
        content: '';
        width: 6px;
        height: 12px;
        margin-right: 3px;
        background-color: #307bff;
      }
    }
    .item-info {
      padding: 0px 12px;
      .top-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: bold;
        color: #333;
        font-size: 12px;
        margin-top: 10px;
        .right-title {
          display: flex;
          align-items: center;
        }
        .ell-icon {
          width: 11px;
          height: 11px;
          margin-right: 5px;
        }
      }
      .item-section {
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .left {
          width: 200px;
          word-break: break-word;
        }
        .right {
          flex: 1;
          text-align: right;
        }
        .img-left {
          width: 126px;
        }
        .img-right {
          display: flex;
          justify-content: flex-end;
          flex-wrap: wrap;
        }
      }
      .custom-section {
        padding: 10px 0;
        border-bottom: 1px solid #e8effc;
        .top-info {
          display: flex;
          justify-content: space-between;
          .left {
            width: 210px;
          }
          .custom-left {
            width: 226px;
          }
          .right {
            flex: 1;
            text-align: right;
          }
        }
        .img-left {
          width: 126px;
        }
        .img-right {
          display: flex;
          flex-wrap: wrap;
          margin-top: 10px;
        }
        .desc-info {
          margin-top: 10px;
          color: #7f7f7f;
        }
        .section-title {
          display: flex;
          align-items: center;
          &.square {
            font-weight: bold;
            &::before {
              content: '';
              width: 8px;
              height: 8px;
              background-color: #307bff;
              // position: absolute;
              // left: 0;
              // top: 0;
              transform: rotate(45deg);
              margin-right: 5px;
            }
          }
        }
        .section-product-name {
          display: flex;
          align-items: center;
          margin-top: 10px;
        }
        .section-quantity-desc {
          padding: 10px;
          margin-top: 8px;
          background-color: #f7f7f7;
          color: #7f7f7f;
          border-radius: 8px;
          .quantity-num,
          .desc-txt {
            &::before {
              content: '#';
              width: 8px;
              height: 8px;
              color: #307bff;
              margin-right: 5px;
            }
          }
          .desc-txt {
            margin-top: 8px;
          }
        }
        .custom-photo-item {
          display: flex;
          justify-content: space-between;
          padding: 10px 0px;
          border-bottom: 1px solid #e8effc;
          &:last-child {
            border-bottom: none;
          }
          .item-left {
            width: 126px;
          }
          .item-right {
            display: flex;
            justify-content: flex-end;
            flex-wrap: wrap;
          }
        }
      }
      .section-title,
      .brand-title,
      .product-title {
        display: flex;
        align-items: center;
        &.square {
          font-weight: bold;
          &::before {
            content: '';
            width: 8px;
            height: 8px;
            background-color: #307bff;
            // position: absolute;
            // left: 0;
            // top: 0;
            transform: rotate(45deg);
            margin-right: 5px;
          }
        }
      }
      .product-title {
        padding-top: 16px;
        color: #333;
        .left-desc {
          flex: 1;
          font-weight: bold;
        }
      }
      .brand-section {
        .product-section {
          border-bottom: 1px solid #e8effc;
        }
        .brand-title {
          padding: 10px 0;
        }
        .quantity-content {
          padding: 10px;
          background-color: #f7f7f7;
          border-radius: 8px;
          margin-bottom: 5px;
          .qt-item {
            color: #7f7f7f;
            &.jin {
              margin-bottom: 8px;
              &::before {
                content: '#';
                width: 8px;
                height: 8px;
                color: #307bff;
                margin-right: 5px;
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
    .img-content {
      padding: 10px;
      padding-bottom: 0;
      .img-imgMap-left {
        margin-bottom: 5px;
      }
    }
    .is-Direct {
      .custom-section {
        padding-bottom: 5px;
      }
      .spec-item {
        margin-bottom: 8px;
        color: #7f7f7f;
        &:last-child {
          margin-bottom: 0;
        }
        .quantity-item {
          margin-bottom: 6px;
          &:last-child {
            margin-bottom: 0;
          }
          &::before {
            content: '#';
            width: 8px;
            height: 8px;
            color: #307bff;
            margin-right: 5px;
          }
        }
      }
      .collapse-title {
        display: flex;
        align-items: center;
        padding: 5px 10px;
      }
      /deep/.van-collapse {
        .van-collapse-item__title {
          padding: 0;
          font-size: 12px;
          background-color: #f7f7f7;
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
          margin-bottom: 0;
        }
        .van-collapse-item__title--expanded::after {
          display: none;
        }
        .van-collapse-item__content {
          padding: 10px;
          font-size: 12px;
          background-color: #f7f7f7;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
        }
        .van-cell__right-icon {
          right: 10px;
          top: 5px;
        }
      }
      /deep/.van-hairline--top-bottom::after {
        display: none;
      }
      .custom-collapse {
        /deep/.van-collapse-item__title {
          border-radius: 10px;
        }
      }
    }
    .material-delivey {
      padding: 10px;
      background-color: #f7f7f7;
      margin-top: 8px;
      border-radius: 8px;
      color: #7f7f7f;
      .material-item {
        margin-bottom: 6px;
        &:last-child {
          margin-bottom: 0;
        }
        &::before {
          content: '#';
          width: 8px;
          height: 8px;
          color: #307bff;
          margin-right: 5px;
        }
      }
    }
    .delivey-total {
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      margin-bottom: 6px;
    }
    .custom-font {
      font-weight: bold;
      color: #307bff;
    }
    .end-of-sales {
      color: #c4200b;
    }
    .jt-icon {
      width: 9px;
      height: 12px;
      margin-right: 5px;
    }
  }
  .oper-btn {
    width: 100%;
    .mapping-btn {
      width: 100%;
      background-color: #307bff;
      font-weight: bold;
    }
  }
  .pcs-num {
    color: #307bff;
    font-weight: bold;
  }
  .photo-img {
    width: 60px;
    height: 60px;
    margin-right: 5px;
    margin-bottom: 5px;
  }
}
.work-dialog {
  overflow: visible;
  /deep/.van-dialog__header {
    font-weight: bold;
  }
  .close-btn-wrapper {
    position: absolute;
    bottom: -50px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>
